import React, {Component} from 'react';
import {Modal,message} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import outerLinkFileIcon from "./outerLinkFile.png";
import BaseComponent from "../../../../../base/BaseComponent";
import {uuid} from "../../../../../utils";
import {Spin} from "antd";
import $ from "jquery";
class LinkCheck extends BaseComponent {

    state = {
        fileList:[],
        visible:false,
        content:'',
        key:1,

    };

    //通过传递内容，解析内容组成图片 content    解析出来数组，[{oldUrl:'',newUrl:'',name}]
    // 解析成功。会返回两个url ，把内容的链接全部替换为转义后的链接。返回内容，并给状态，status 为true 继续推进流程
    // 全部转义，false 为存在没有转化的，
    componentDidMount() {
        /*let content1='<div>' +            '<img src="xxxxx" alt="测试外连接图片">' +
            '<img src="//storage//__local/E/F3/EC/86DE41AED506CB3660B1C50FBD8_5E543AFD_171AC.jpg" alt="测试外连接图片">' +
            '<img src="https://news.dlut.edu.cn/__local/E/F3/EC/86DE41AED506CB3660B1C50FBD8_5E543AFD_171AC.jpg" alt="测试外连接图片2"><img src="https://news.dlut.edu.cn/__local/E/F3/EC/86DE41AED506CB3660B1C50FBD8_5E543AFD_171AC.jpg" alt="测试外连接图片3"></div>'
        let content2='';
        this.show(content1,(res)=>{
            console.log(res)
        })*/
    }

    show(oldContent, callback) {
        let content=this.getNewContent(oldContent);
        let checkList=window.sysConfigGetValueByKey('abnormalResources','["/storage/"]');
         let newCheckList=checkList?JSON.parse(checkList):[];
        content='<div>'+content+'</div>';
        console.log(content)
        //获取所有的图品组装数组

        this.callback = callback;
        let imgList = $(content).find('img');
        this.state.content = oldContent;
        console.log(imgList);
        if (imgList.length) {
            let fileList = [];
            for (let i = 0; i < imgList.length; i++) {
                let item = imgList[i];
                let url = $(item).attr('src');
                let checkNUm=0;
                newCheckList.forEach((item,index)=>{
                    let  expression = new RegExp(item);
                    if(expression.test(url)){
                        checkNUm++;
                    }
                });

                if (checkNUm==0) {
                    let name=$(item).attr('name')||$(item).attr('alt')||$(item).attr('src');
                    let isOtherFileStatus=false;
                    let isOtherFile=['video','audio']; //img 是web 编辑器的别名。微信，微博都用没有别名，所以不能img 取反
                    if(isOtherFile.indexOf($(item).attr('alias-label'))>-1){
                        isOtherFileStatus=true;
                    }
                    fileList.push({
                        oldUrl: $(item).attr('src'),
                        newUrl: '',
                        isReplace: false,
                        isOtherFileStatus: isOtherFileStatus,
                        name: name,
                    })
                }
            }
            if (fileList.length) {
                this.setState({
                    visible: true,
                    fileList,
                    content:oldContent,
                }, () => {
                    this.transFormFile()
                })
            }else{
                this.noOtherFile()
            }
        } else {
            this.noOtherFile()
        }
    }

    getNewContent(oldContent){
        let content='';
        if(typeof  oldContent=='string'){
            content=oldContent;
        }else if(oldContent instanceof Array ){
            if(oldContent&&Array.length){
                oldContent.forEach(item=>{
                    if(item.content){
                        content=content+item.content;
                    }
                })
            }
        }
        return  content
    }

    noOtherFile() {
        //如果内容合法，资源合法直接回传
        let data = {content: this.state.content, status: true};
        if (this.callback) {
            this.callback(data)
        }
        this.props.callback && this.props.callback(data);
        this.setState({visible: false})
    }

    transFormFile(){
        let {fileList}= this.state;
        fileList.forEach((item, index) => {
            let url = item.oldUrl;
            if (url&&!item.isOtherFileStatus) {
                this.request({
                    url: "/storage/getByExternalUrl",
                    method: 'post',
                    loading: false,
                    body: {url},
                    callBack: (data) => {
                        if (data.path) {
                            window.reactNotification.success({key:data.md5, message:'异常资源转化', duration:5, description:"你有一张异常资源自动保存成功"});
                            fileList[index].newUrl = data.path;
                            fileList[index].isReplace = true;
                            this.setState({fileList}, () => {
                                console.log('----转换后的数据', this.state.fileList)
                                let conVertAll=true;
                                this.state.fileList.map(item=>{
                                    if(!item.isReplace){
                                        conVertAll=false;
                                    }
                                });
                                //如果全部转化完成，自动关闭
                                if(conVertAll){
                                   this.onOk()
                                }
                            })
                        }
                    },
                    serverVerify:{
                        isShowErrorMsg:false,
                        serverErrorCallBack:()=>{
                            message.destroy();
                            message.error('资源自动保存失败')
                        }
                    },
                    errorCallBack:()=>{
                        message.destroy()
                        message.error('资源自动保存失败')
                    }
                })
            }
        });
    }

    render() {
        return (
            <div>
                <LinkFileModal fileList={this.state.fileList} key={this.state.key} visible={this.state.visible} onOk={() => {
                    this.onOk()
                }} onCancel={() => {
                    this.setState({key:uuid()});
                    this.onCancel()
                }}/>
            </div>
        );
    }

    onOk() {
        let content = this.state.content;
        const {fileList} = this.state;
        let uploadAllFile = false;
        let num = 0;
        if(typeof  content  =='string'){
            fileList.forEach((item, index) => {
                if (item.isReplace) {
                    content = content.replace(item.oldUrl, item.newUrl);
                    num++;
                }
            });
        }else if(content instanceof Array ){
            if(content&&content.length){
                content.forEach((Item,Index)=>{
                    let currentContent=Item.content||'';
                    if(currentContent){
                        fileList.forEach((item, index) => {
                            if (item.isReplace&&currentContent.indexOf(item.oldUrl)>-1) {
                                currentContent = currentContent.replace(item.oldUrl, item.newUrl);
                                num++;
                            }
                            if(index==fileList.length-1){
                                content[Index].content=currentContent;
                            }
                        });
                    }

                })
            }
        }
            console.log(content)
        if (num == fileList.length || (num = 0 && fileList == 0)) {
            uploadAllFile = true
        }
        if(!uploadAllFile){
            message.warning('存在异常资源无法自动上传成功，请手动修改!')
        }
        let data = {content: content, status: uploadAllFile};
        if (this.callback && typeof this.callback == 'function') {
            this.callback(data)
        }
        this.props.callback && this.props.callback(data);
        this.setState({visible: false})
    }

    onCancel() {
        this.setState({visible: false})
    }
}

class LinkFileModal extends BaseComponent{

    render() {
        return <Modal
            width={670}
            title={"内容外链文件"}
            visible={this.props.visible}
            onOk={()=>{this.props.onOk()}}
            onCancel={()=>{this.props.onCancel()}}
        >
            <table style={{lineHeight:3}} cellPadding={0} cellSpacing={0} border={0} width={"100%"}><tbody>
            <tr>
                <td width={80} align={"right"}>异常信息：</td>
                <td style={{color:"#000"}}>当前稿件内容包含<span>非融媒体系统的资源</span>。如不处理，发布后可能无法正常显示</td>
            </tr>
            <tr>
                <td align={"right"}>解决方法：</td>
                <td style={{color:"#000"}}>请先将资源下载到本地，再上传至融媒体系统后发布</td>
            </tr>
            {
                this.props.fileList && this.props.fileList.length && this.props.fileList.some(item=>!item.isReplace) ? (
                    <tr>
                        <td align={"right"} valign={"top"}>异常资源：</td>
                        <td valign={"top"} style={{paddingTop:15}}>
                            <Scrollbars
                                autoHeight={true}
                                autoHeightMax={300}
                                autoHide
                            >
                                {this.props.fileList && this.props.fileList.map((item, index)=>{
                                    if(!item.isReplace){
                                        return <ImageItem key={index} name={item.name} url={item.newUrl||item.oldUrl}/>
                                    }
                                })}
                            </Scrollbars>
                        </td>
                    </tr>
                ) : null
            }
            </tbody></table>
        </Modal>;
    }
}

class ImageItem extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            url : props.oldUrl,
            status:"done",
            percent:0
        };
    }

    render() {
        let {name} = this.props;
        let src = this.props.url;
        if(!src){
            src = outerLinkFileIcon;
        }
        let img = new Image();
        img.src=src;
        //判断图片大小是否大于0 或者 图片高度与宽度都大于0
        if(img.filesize>0||(img.width>0&&img.height>0)){
            src=this.props.url
        }else{
            //默认图片也不存在的时候
            src=outerLinkFileIcon
        }

        let size = 88;
        return <div style={{float:"left", marginRight:20, marginBottom:15,position:"relative"}}>
            <img width={size} height={size} style={{objectFit:"cover"}} src={src} /><br />
            <div style={{lineHeight:2,overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis',width:size}} title={name}>{name}</div>
            {this.state.status === "loading" && <table style={{position:"absolute", top:0, left:0, background:"#cbcbcb", opacity:0.8}} cellSpacing={0} cellPadding={0} border={0} width={"100%"} height={size}><tbody><tr><td valign={"middle"} align={"center"}>
                <Spin/>
            </td></tr></tbody>
            </table>}
        </div>
    }
}

export default LinkCheck;